/** @jsx h */

const TeaserPublications = ({ result }) => {
  return (
    <article className="search-result__article">
      {result.date && (
        <div className="search-result__date">
          <time datetime={result.date}>{result.date}</time>
        </div>
      )}
      <div className="search-result__content">
        <header className="search-result__header">
          <h3 className="search-result__heading">
            {result.url ? (
              <a
                className="styled-link styled-link--internal"
                href={result.url}
                {...(result.isExternal
                  ? { target: '_blank', rel: 'noopener' }
                  : '')}
              >
                <span className="styled-link__text">{result.title}</span>
              </a>
            ) : (
              result.title
            )}
          </h3>
        </header>
        <p className="search-result__subtext">{result.subtitle}</p>
        {result.teaser && (
          <p
            className="search-result__text"
            dangerouslySetInnerHTML={{
              __html: result.teaser,
            }}
          />
        )}
      </div>
      <div class="search-result__details">
        {result.image && (
          <figure class="search-result__figure">
            <picture>
              <img
                className="search-result__image"
                src={result.image.src}
                alt={result.image.alt}
                title={result.image.title}
              />
            </picture>
          </figure>
        )}
        {result.download &&
          result.download.map((download, index) => (
            <a
              class="styled-link styled-link--download"
              key={`${result.id}-document-${index}`}
              href={download.url}
              target="_blank"
              rel="noreferrer"
            >
              <span className="icon icon--download">
                <svg className="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-download" />
                </svg>
              </span>
              <span className="styled-link__text">
                {download.title ? download.title : 'PDF zum Download'}
              </span>
            </a>
          ))}
      </div>
    </article>
  );
};

export default TeaserPublications;
